import React from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { applyEventDiscount, addItem } from "../../../ReduxToolkit/Reducers/CartReducer";
import { getVendorSettings } from "../../../services/helper";

export default function EventDiscountButton() {
  const dispatch = useDispatch();
  const { cartItems, products, applied_event } = useSelector((state) => state.cart);

  const getTodaysEvent = () => {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    const todayMonth = today.substring(5); // MM-DD for recurring
    
    const savedEvents = getVendorSettings("event_discounts");
    if (!savedEvents) return null;

    try {
      const events = JSON.parse(savedEvents);
      return events.find(event => {
        if (event.recurring) {
          return event.dates.some(date => date.substring(5) === todayMonth);
        }
        return event.dates.includes(today);
      });
    } catch (error) {
      console.error("Failed to parse event discounts:", error);
      return null;
    }
  };

  const checkEventScenarioMatch = (event) => {
    if (!event || cartItems.length === 0) return false;

    const subtotal = cartItems.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );

    console.log('Event check:', event.type, event);
    console.log('Cart items:', cartItems);

    switch (event.type) {
      case "percentage":
      case "fixed_amount":
        if (event.items.length === 0) return true; // Apply to all items
        return cartItems.some(item => 
          event.items.some(eventItem => 
            item.name.toLowerCase().includes(eventItem.toLowerCase())
          )
        );

      case "buy_one_get_one":
        const buyItems = cartItems.filter(item => 
          item.name.toLowerCase().includes(event.buyItem.toLowerCase())
        );
        
        // Check if buy and get items are the same
        if (event.buyItem.toLowerCase() === event.getItem.toLowerCase()) {
          // Same item BOGO - count total quantity of all matching items
          const totalQuantity = buyItems.reduce((sum, item) => sum + item.quantity, 0);
          return totalQuantity >= 2;
        } else {
          // Different items BOGO - need both items
          const getItems = cartItems.filter(item => 
            item.name.toLowerCase().includes(event.getItem.toLowerCase())
          );
          const buyQuantity = buyItems.reduce((sum, item) => sum + item.quantity, 0);
          const getQuantity = getItems.reduce((sum, item) => sum + item.quantity, 0);
          return buyQuantity >= 1 && getQuantity >= 1;
        }

      case "free_item":
        return cartItems.some(item => 
          event.items.some(eventItem => 
            item.name.toLowerCase().includes(eventItem.toLowerCase())
          )
        );

      case "no_tax":
        return true; // Can always apply no tax

      case "second_item_discount":
        // Check if we have the first item and at least 2 total items in cart
        const firstItems = cartItems.filter(item => 
          item.name.toLowerCase().includes(event.buyItem.toLowerCase())
        );
        const firstItemQuantity = firstItems.reduce((sum, item) => sum + item.quantity, 0);
        const totalCartItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
        
        console.log('Second item discount check:', event.buyItem, firstItemQuantity, 'total items:', totalCartItems);
        // Need at least 1 of the first item and at least 2 total items
        return firstItemQuantity >= 1 && totalCartItems >= 2;

      case "minimum_purchase":
        const minAmount = parseFloat(event.minAmount);
        return subtotal >= minAmount;

      default:
        return false;
    }
  };

  const handleApplyEventDiscount = () => {
    const todaysEvent = getTodaysEvent();
    
    if (!todaysEvent) {
      toast.info("No event discount available for today");
      return;
    }

    if (cartItems.length === 0) {
      toast.error("Cart is empty");
      return;
    }

    dispatch(applyEventDiscount(todaysEvent));
    toast.success(`Applied: ${todaysEvent.name}`);
  };

  const getBOGOMessage = (event) => {
    if (event?.type !== "buy_one_get_one") return null;
    
    const buyItems = cartItems.filter(item => 
      item.name.toLowerCase().includes(event.buyItem.toLowerCase())
    );
    
    // Check if buy and get items are the same
    if (event.buyItem.toLowerCase() === event.getItem.toLowerCase()) {
      // Same item BOGO - count total quantity
      const totalQuantity = buyItems.reduce((sum, item) => sum + item.quantity, 0);
      if (totalQuantity === 1) {
        return `Add another ${event.getItem} to get it free!`;
      }
    } else {
      // Different items BOGO
      const getItems = cartItems.filter(item => 
        item.name.toLowerCase().includes(event.getItem.toLowerCase())
      );
      const buyQuantity = buyItems.reduce((sum, item) => sum + item.quantity, 0);
      const getQuantity = getItems.reduce((sum, item) => sum + item.quantity, 0);
      
      if (buyQuantity >= 1 && getQuantity === 0) {
        return `Add ${event.getItem} to get it free!`;
      }
    }
    
    return null;
  };

  const todaysEvent = getTodaysEvent();
  const hasMatchingScenario = checkEventScenarioMatch(todaysEvent);
  const bogoMessage = getBOGOMessage(todaysEvent);

  // Show message if BOGO buy item exists but get item doesn't
  if (todaysEvent?.type === "buy_one_get_one" && bogoMessage) {
    return (
      <div className="text-center mb-2 p-2 bg-light border rounded">
        <small className="text-muted">{bogoMessage}</small>
      </div>
    );
  }

  // Hide button if event is already applied
  if (applied_event) {
    return null;
  }

  // Only render button if there's an event and it matches current cart scenario
  if (!todaysEvent || !hasMatchingScenario) {
    return null;
  }

  return (
    <Button
      color="warning"
      size="sm"
      onClick={handleApplyEventDiscount}
      disabled={cartItems.length === 0}
      className="w-100 mb-2"
    >
      Event: {todaysEvent.name}
    </Button>
  );
}